import FileSaver from 'file-saver';

export const exportContactCard = (card, name) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.download = `${name}.vcf`;
    downloadLink.textContent = name;
    const blob = new Blob([card], { "type": "text/vcard" });
    FileSaver.saveAs(blob, downloadLink.download);
    document.body.removeChild(downloadLink);
};
